import { useState as a, useEffect as i, useContext as u, useCallback as c } from "react";
import { TrackingContext as l, trackEvent as d } from "./core-analytics/dist/index.js";
import f from "./help-text/help-text.module.less.js";
import m from "./validation-message/validation-message.module.less.js";
import { version as p, name as b } from "./builders-components/package.json.js";
const s = typeof window < "u" && typeof window.document < "u" && typeof window.navigator < "u", E = s && /android/i.test(window.navigator.userAgent), S = s && /iPad|iPhone|iPod/.test(window.navigator.userAgent);
function T() {
  const [e, t] = a(() => {
  });
  return i(() => {
    t(`:b${window.buildersUUID = (window.buildersUUID || 0) + 1}`);
  }, []), e;
}
function x(e) {
  i(() => {
    window.requestAnimationFrame(() => {
      if (e.current instanceof HTMLElement) {
        const t = e.current;
        t.closest("label") || t.id && document.querySelector(`label[for="${t.id}"]`) || console.warn(
          "Form element missing <Label>. Please set an id={exampleId} and corresponding <Label htmlFor={exampleId}>:",
          t
        );
      }
    });
  }, [e]);
}
function L(e) {
  const { options: t } = u(l);
  return c(
    (n) => {
      e && d(
        {
          eventVersion: p,
          eventSource: b,
          eventLabel: "",
          ...n,
          ...e === !0 ? {} : e
        },
        t
      );
    },
    [e, t]
  );
}
function o(e) {
  return e instanceof HTMLElement ? (e.innerText || e.textContent || e.getAttribute("aria-label") || "").replace(/\n/g, " ").trim() : "";
}
function k(e) {
  var r;
  if (e instanceof HTMLInputElement && (e = (r = e.labels) == null ? void 0 : r[0]), !(e instanceof HTMLElement))
    return "";
  const t = o(e.querySelector(f.helpText)), n = o(e.querySelector(m.message));
  return o(e).replace(t, "").replace(n, "");
}
function D(e) {
  if (e.key === " " || e.key === "Enter") {
    const t = new MouseEvent("click", { bubbles: !0, cancelable: !0 });
    e.preventDefault(), e.currentTarget.dispatchEvent(t);
  }
}
export {
  E as IS_ANDROID,
  s as IS_BROWSER,
  S as IS_IOS,
  k as getLabel,
  o as getText,
  D as onRoleButtonKeyDown,
  T as useId,
  x as useReqireLabel,
  L as useTracking
};
//# sourceMappingURL=utils.js.map
